/* lua.js generated code undefined */

let Base = unpack(require("clover/logic/userTagData/UserTagBase"))[0]
let Active30DayTagConfig = require("clover/config/userTag/Active30DayTagConfig")
let Tag = xClass("Active30DayTag", Base)
Tag.prototype.init = function () {
    let self = this
    self.record = table()
    self.active30Days = 0
}
Tag.prototype.convertOnlineRecord = function (data) {
    let self = this
    // if __DEBUG then
    // 	return {record = {
    // 		1589004000,
    // 		1588964400,
    // 		1588878000
    // 	}}
    // end
    return table([1, "record", data.dayActives])
}
Tag.prototype.refresh = function (data) {
    let self = this
    // print("#### DA Active30DayTag:refresh", data)
    // if (data.record) {
    //     self.record = data.record
    //     self.active30Days = 0
    //     let daySet = table()
    //     let todayStart = Localhost.getTodayStart()
    //     for (let _ in self.record) {
    //         let loginStamp = self.record[_]
    //         if ($null(loginStamp)) continue
    //         let dayStart = Localhost.getDayStartTimeByTS(loginStamp)
    //         let todayStart = Localhost.getTodayStart()
    //         let loginDay = Localhost.timeInDay(todayStart - dayStart)
    //         if (loginDay > 0 && loginDay <= 30) {
    //             if (daySet[dayStart] === null) {
    //                 daySet[dayStart] = loginStamp
    //                 if (dayStart !== todayStart) { //不含当天不含注册当天
    //                     self.active30Days = self.active30Days + 1
    //                 }
    //             }
    //         }
    //     }
    // }
}
Tag.prototype.getTag = function () {
    let self = this
    // print("【掉落优化】30日活跃计算 活跃天数="..tostring(self.active30Days))
    // DAManagerGUILogger:getInstance():print("【掉落优化】30日活跃计算 活跃天数="..tostring(self.active30Days))
    self.active30Days = UserManager.getInstance().userLabel.loginNum30
    for (let label in Active30DayTagConfig) {
        let v = Active30DayTagConfig[label]
        if ($null(v)) continue
        if (v.type === "login") { //比较登陆天数
            // print("【掉落优化】30日活跃计算 min="..tostring(v.min).."max="..tostring(v.max))
            // DAManagerGUILogger:getInstance():print("【掉落优化】30日活跃计算 min="..tostring(v.min).."max="..tostring(v.max))
            if (self.active30Days >= v.min && self.active30Days <= v.max) { //活跃天数（不含当天）
                // print("【掉落优化】30日活跃标签="..tostring(label))
                // DAManagerGUILogger:getInstance():print("【掉落优化】30日活跃标签="..tostring(label))
                return tonumber(label)
            }
        }
    }
    return 0
}
Tag.prototype.encode = function () {
    let self = this
    let data = table([1, "record", self.record])
    return data
}
module.exports = Tag
